import React from "react";

// MATERIAL UI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
// ICONS
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import { grey } from "@mui/material/colors";

export default function DashboardNoShippingRouteAlert() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{
        textAlign: "center",
        padding: 4,
        border: "1px solid #ccc",
        borderRadius: 2,
        backgroundColor: grey["50"],
      }}
    >
      <Box>
        <DeliveryDiningIcon sx={{ fontSize: 48, color: "#ff5722" }} />
      </Box>
      <Typography variant="h5" component="h5">
        Nenhuma Entrega Na Rua
      </Typography>
      <Typography variant="body1" component="p" color="textSecondary">
        Nenhum pedido na rua. Aqui aparecerão todos os seus pedidos na rua que
        ainda não tiveram o retorno confirmado.
      </Typography>
    </Stack>
  );
}
